import * as loading from '../../store/actions/loading'
import objectPath from "object-path"

export function getLoadingKey(name){
	return Array.isArray(name) ? name : [name]
}

/**
 * Returns if the passed loading object is loading
 * Pass in an object or pass in a root object and a lookup key
 * @param state
 * @param key
 * @returns {*|boolean}
 */
export function isLoading(state, key=false){
	if(key)	state = objectPath.get(state, key, false)

	return (state && state.isLoading) || false
}

/**
 * Returns if the passed loading object has errored
 * Pass in an object or pass in a root object and a lookup key
 * @param state
 * @param key
 * @returns {*}
 */
export function hasErrored(state, key=false){
	if(key)	state = objectPath.get(state, key, false)

	if(state && !isLoading(state) && state.exception){
		return state.exception
	}

	return false
}

export function hasErroredObject(state, key=false){
	if(key)	state = objectPath.get(state, key, false)

	if(state && !isLoading(state) && (state.exception || state.exceptionCode)){
		return state
	}

	return false
}

/**
 * Returns if the error is a network error
 * Pass in an object or pass in a root object and a lookup key
 * @param state
 * @param key
 * @returns {*|boolean}
 */
export function isNetworkError(state, key=false){
	if(key)	state = objectPath.get(state, key, false)

	return state && state.exceptionType && state.exceptionType === loading.EXCEPTION_TYPE_NETWORK
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/util/loading.js